import { styled } from '@mui/system';

export const AnimationContainerStyled = styled('div')`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const CloudElementStyled = styled('svg')<{ zIndex: number }>`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: ${({ zIndex }) => zIndex};
  display: flex;
  width: 100%;
  opacity: 0;
`;
